module.exports = __webpack_public_path__ + "static/media/ic-4.2bbae3fa.svg";